import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { slideVariants } from "./MobileStep";

/**
 * RegisterStep — Step 3: user completes their missing name
 * Props: fullName, setFullName, nameError, onSave
 */
const RegisterStep = ({ fullName, setFullName, nameError, onSave }) => (
  <motion.div
    key="register"
    variants={slideVariants}
    initial="enter"
    animate="center"
    exit="exit"
    className="flex flex-col"
  >
    {/* Icon + heading */}
    <div className="flex flex-col items-center mb-5">
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3 shadow-md bg-[#00713b]"
      >
        <svg className="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
      <h2 className="text-2xl font-black text-gray-900 mb-1 tracking-tight">Your Name</h2>
      <p className="text-xs text-gray-500 font-medium text-center">
        What should we call you?
      </p>
    </div>

    {/* Name input */}
    <div className="flex flex-col mb-5">
      <label className="text-[11px] font-bold text-gray-500 uppercase tracking-widest mb-2 px-1">
        Your Name
      </label>
      <input
        id="login-name-input"
        type="text"
        placeholder="Enter your full name"
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onSave(); }}
        className={`w-full border rounded-2xl px-4 py-3.5 bg-white outline-none text-base text-gray-900 placeholder-gray-400 font-semibold transition-all duration-200 ${
          nameError
            ? "border-rose-400 bg-rose-50/30"
            : "border-[#22c55e]/30 focus:border-emerald-600 focus:ring-2 focus:ring-emerald-500/15"
        }`}
      />
      <AnimatePresence>
        {nameError && (
          <motion.span
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="text-[11px] text-rose-500 font-bold mt-1.5 px-1"
          >
            {nameError}
          </motion.span>
        )}
      </AnimatePresence>
    </div>

    {/* Save & Enter button */}
    <motion.button
      id="login-save-btn"
      onClick={onSave}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.97 }}
      className="w-full py-3.5 text-white font-semibold rounded-2xl text-base shadow-lg transition-all duration-200"
      style={{ background: "linear-gradient(90deg, #00713b 0%, #04b26b 100%)" }}
    >
      Save &amp; Enter
    </motion.button>
  </motion.div>
);

export default RegisterStep;
